import { connect } from 'react-redux'
import UI from './UI'
import { selectVideoToWatch, showPopUp } from 'pages/Course/store'
import { createQuizAttemptAction, openQuiz, setQuestionPosition } from 'pages/Course/Quizz/store'

const mapStateToProps = ({ course, identity, quiz }) => ({
  Chapters: course.Course.Chapters,
  IsFree: course?.Course?.IsFree,
  isConnected: identity.isConnected,
  currentVideo: course.currentVideo ?? {},
  learningMode: course.Course.IsAccessible,
  Slug: course.Course.Slug,
  IsAccessible: course.Course.IsAccessible,
  courseId: course.Course.Id,
  Questions: quiz.Questions?.length,
  isQuizOpen: quiz.isQuizOpen,
  CompletionPercentage: course.Course.CompletionPercentage
})

const mapDispatchToProps = dispatch => ({
  selectVideoToWatch: video => dispatch(selectVideoToWatch(video)),
  openQuiz: isOpen => dispatch(openQuiz(isOpen)),
  createAttempt: courseId => dispatch(createQuizAttemptAction(courseId)),
  setQuestionPosition: position => dispatch(setQuestionPosition(position)),
  showPopUpAction: state => dispatch(showPopUp(state))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
